import React from 'react';

export default function PsFieldError({ meta }) {
  return (
    <div>
      {meta.touched &&
        meta.error && <span style={{ color: '#a94442' }}>{meta.error}</span>}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/inputs/PsFieldError.js